<template>
  <div>
    <title-edit header="Venue hire" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8"  xs="12" style="text-align: right">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Venue hire* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option
          :model="form.venue_hire_id"
          :items="optionVenueHire"
          @update="updateVenueHire"
        />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Venue hire detail TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.name_th" @update="updateNameTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Venue hire detail EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.name_en" @update="updateNameEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Floor* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :model="form.floor_id" :items="optionFloor" @update="updateFloor" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Slug Url :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.slug_url" @update="updateSlugURL" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Slide image* :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px
        </div>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <v-row>
          <v-col v-for="(image, index) in form.slide_images" :key="index" cols="4">
            <v-card @click="removeImage(index)">
              <v-img
                :src="image.image_path_show"
                title="click for remove image"
                width="250px"
                height="200px"
              />
            </v-card>
          </v-col>
        </v-row>
        <input-image-upload id="image" @update="updateSlideImage" width="150px" height="150px" />
      </v-col>
    </div>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteVenueHireDetails" />
      <preview-button />
      <save-button @click.native="saveVenueHireDetails" />
    </div>
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import InputTextField from "../../../components/Input/InputTextField";
import InputEditor from "../../../components/Input/InputEditor";
import SelectOption from "../../../components/Input/selectOption";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import LineHr from "../../../components/Icon/line-hr";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import SwitchSelect from "../../../components/Input/StyleUtility";
import { mapState } from "vuex";
export default {
  name: "VenueHireDetailsEdit",
  components: {
    SwitchSelect,
    SaveButton,
    PreviewButton,
    DeleteButton,
    LineHr,
    InputImageUpload,
    SelectOption,
    InputEditor,
    InputTextField,
    TitleEdit
  },
  computed: {
    ...mapState({
      form: state => {
        return state.VenueHireDetails.form;
      }
    })
  },
  created() {
    this.getVenueHireAll();
    this.getFloorData();
  },
  data() {
    return {
      optionVenueHire: [],
      optionFloor: []
    };
  },
  methods: {
    getFloorData() {
      this.$store.dispatch("Floor/getFloorAll").then(res => {
        this.optionFloor = [
          { text: "Select", value: "" },
          ...res.map(type => ({
            value: type.floor_id,
            text: type.floor_number +'-'+type.floor_name
          }))
        ];
      });
    },
    getVenueHireAll() {
      this.$store.dispatch("VenueHire/getAllVenueHire").then(res => {
        this.optionVenueHire = [
          { text: "Select", value: "" },
          ...res.map(type => ({
            value: type.id,
            text: type.name_th + " (" + type.name_en + ")"
          }))
        ];
      });
    },
    goToVenueHireDetailsTable() {
      this.$router.push("/services/venue-hire-details");
    },
    validateSave() {
      if (!this.form.name_th) {
        alert("please insert Venue hire detail TH !");
        return false;
      } else if (!this.form.name_en) {
        alert("please insert Venue hire detail EN !");
        return false;
      } else if (!this.form.description_th) {
        alert("please insert Description TH !");
        return false;
      } else if (!this.form.description_en) {
        alert("please insert Description EN !");
        return false;
      } else if (!this.form.venue_hire_id) {
        alert("please select Venue hire !");
        return false;
      } else if (!this.form.floor_id) {
        alert("please select Floor !");
        return false;
      } else {
        return true;
      }
    },
    saveVenueHireDetails() {
      if (this.validateSave()) {
        this.$store
          .dispatch("VenueHireDetails/saveVenueHireDetails", {
            id: this.form.id,
            data: this.form
          })
          .then(res => {
            alert(res.response_msg);
            if (res.response_code == 200) {
              this.goToVenueHireDetailsTable();
            }
          })
          .catch(() => {
            alert("cannot save venue hire details!");
          });
      }
    },
    deleteVenueHireDetails() {
      this.$store
        .dispatch("VenueHireDetails/deleteVenueHireDetails", this.form.id)
        .then(res => {
          alert(res.response_msg);
          if (res.response_code == 200) {
            this.goToVenueHireDetailsTable();
          }
        })
        .catch(() => {
          alert("cannot delete venue hire details!");
        });
    },
    updateSlideImage(val) {
      let slide_image = val.imagePath;
      let image_path_show = val.fullImagePath;
      let data = {
        slide_image,
        image_path_show,
      };
      this.$store.dispatch("VenueHireDetails/addImage",data);
    },
    removeImage(index){
      this.$store.dispatch("VenueHireDetails/removeImage",index)
    },
    updateVenueHire(val) {
      this.form.venue_hire_id = val;
    },
    updateFloor(val) {
      this.form.floor_id = val;
    },
    updateNameTH(val) {
      this.form.name_th = val;
    },
    updateNameEN(val) {
      this.form.name_en = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateImage(val) {
      this.form.images = val.imagePath;
      this.form.images_show = val.fullImagePath;
    },
    updateSlugURL(val) {
      this.form.slug_url = val;
    }
  }
};
</script>

<style scoped>
.label {
  text-align: right;
}
</style>
